/** Home page sections, in display order. `visible: false` hides a section. */
export const sections = [
  { id: 'manifesto', visible: true },
  { id: 'services', visible: true },
  { id: 'industries', visible: true },
  { id: 'portfolio', visible: true },
  { id: 'pricing', visible: true },
  { id: 'process', visible: true },
  { id: 'tech', visible: true },
  { id: 'about', visible: true },
  { id: 'testimonials', visible: true },
  { id: 'blog', visible: true },
  { id: 'faq', visible: true },
  { id: 'contact', visible: true },
];
